import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/70 pt-14 pb-8">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/10">
                <i className="ri-spy-line text-lg text-background-50"></i>
              </div>
              <span className="text-lg font-bold text-background-50 whitespace-nowrap">黑料在线</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/50">
              最新独家黑料内容聚合平台<br />
              深度挖掘真相，畅享全方位资讯体验
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 3).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">更多分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(3).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">
                  用户口碑
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 黑料在线 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}